/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import {
  Link,
  Text,
} from "@chakra-ui/react";

export default function Footer() {
  let textColor = "gray.400";
  let year = 1900 + new Date().getYear();
  let [version, setVersion] = useState(null);
  const { t } = useTranslation();
  useEffect(() => {
    try {
      const base = process.env.REACT_APP_API_BASE_URL || "";
      if (!base) return;
      fetch(base.replace(/\/$/, '') + '/version/')
        .then((resp) => resp.json())
        .then((data) => { setVersion(data && (data.latest || data.version || null)) })
        .catch(() => {});
    } catch (_) {}
  }, []);
  return (
  <>
    <Text color={textColor} textAlign='center' mb={4}>
      <Link color={textColor} href='https://inohom.com/' target='_blank'>
        İnohom,
      </Link> {t('footer.brand_notice', { year })} { version && t('footer.version', { version }) }
    </Text>
  </>
  );
}
